import React, { useState, useEffect }from "react";
import { useSearchParams, useOutletContext } from "react-router-dom";
import PaginationSection from "../../../components/Product/Pagination";
import MyOrderItem from "./MyOrderItem";
import MyCount from "../../../components/MyPage/MyCount";
import MyOrderTerm from "../../../components/MyPage/MyOrderTerm";
import { MY_PAGE_ESTIMATE_ORDER_LIST_URL } from "../../../utils/urls";
import instance from "../../../services/services";
import { useLanguage } from "../../../hooks/useLanguage";

function OrderManagement(){
  const { t } = useLanguage();
  const [isTablet, setIsTablet] = useState(false);
  const { myInfo } = useOutletContext();
  const [orderList, setOrderList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const itemsPerPage = 10;
  const [dateRange, setDateRange] = useState({ sdate: "", edate: "" });
  const [shouldFetch, setShouldFetch] = useState(true); // 서버 통신 트리거 플래그

  // 모바일 체크
  useEffect(() => {
    const checkTablet = () => {
      setIsTablet(window.innerWidth < 768);
    };
    
    checkTablet();
    window.addEventListener('resize', checkTablet);
    
    return () => window.removeEventListener('resize', checkTablet);
  }, []);
  
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const titles = {
    visit : t('store_order_management2'),
    parcel : t('delivery_management'),
    estimate:t('quotation_management'),
    sale:t('sale_product_order_management')
  };

  // 페이지 변경 핸들러
  const handlePageChange = (page) => {
    setCurrentPage(page);
    setShouldFetch(true); // 페이지 변경 시 서버 통신 트리거
  };

  // 화살표 클릭 핸들러
  const handleArrowClick = (page) => {
    handlePageChange(page);
  };

  // MyOrderTerm에서 조회 버튼 클릭 시 호출되는 핸들러
  const handleDateChange = (dates) => {
    setDateRange(dates);
    setShouldFetch(true); // 조회 버튼 클릭 시 서버 통신 트리거
  };

  // 주문 목록 가져오기
  useEffect(() => {
    if (!shouldFetch) return; // shouldFetch가 false면 API 호출하지 않음
    
    const fetchOrderList = async () => {
      try {
        const response = await instance.post(MY_PAGE_ESTIMATE_ORDER_LIST_URL, {
          sdate: dateRange.sdate,
          edate: dateRange.edate,
          offset: currentPage,
          limit: itemsPerPage,
          order_kind: type
        });
        
        // 원래 구조: response.data.data.data[type] 사용
        // 데이터가 없을 때는 response.data.data가 배열이므로 안전하게 처리
        const responseData = response.data.data;
        
        // response.data.data.data[type] 구조 확인
        if (responseData && typeof responseData === 'object' && !Array.isArray(responseData) && responseData.data) {
          // 데이터가 있는 경우: response.data.data.data[type]
          const orderData = responseData.data[type];
          setOrderList(Array.isArray(orderData) ? orderData : []);
          setTotalCount(parseInt(responseData.total_count) || 0);
        } else {
          // 데이터가 없는 경우: response.data.data가 배열이거나 다른 구조
          setOrderList([]);
          setTotalCount(parseInt(responseData?.count) || parseInt(responseData?.total_count) || 0);
        }

        setShouldFetch(false); // 데이터 가져온 후 서버 통신 트리거 해제
      } catch (error) {
        console.error('주문 목록 가져오기 실패:', error);
        setShouldFetch(false);
      }
    };
    
    fetchOrderList();
  }, [type, currentPage, dateRange, shouldFetch]);

  // 타입이 변경되었을 때 상태 초기화 및 서버 통신 트리거
  useEffect(() => {
    if (type) {
      // 타입이 변경될 때 상태값 초기화
      setCurrentPage(1);
      setDateRange({ sdate: "", edate: "" });
      setOrderList([]);
      setTotalCount(0);
      setShouldFetch(true);
    }
  }, [type]);

  return(
    <div>
      {/* 장바구니 / 관심상품 / 쿠폰 */}
      {!isTablet && <MyCount/>}

      {/* 기간 조회 - type을 key로 사용하여 탭 변경 시 컴포넌트 재생성 */}
      <MyOrderTerm 
        key={`orderterm-${type}`} 
        onDateChange={handleDateChange} 
      />
      
      <div>
        {/* 관리 메뉴들에 대한 ui */}
        {titles[type] ? (
          <div className="my_container">
            <div className="order_title">
              <h3>{titles[type]}</h3>
            </div>
            {orderList.length > 0 ? (
              <MyOrderItem 
              type={type} 
              orderList={orderList} 
              memberSeq={myInfo?.member_seq}
            />
            ) : (
              <div className="no_result">
              <p>상품이 없습니다.</p>
            </div>
            )}
          </div>
        ) :  null}

        {/* 페이지네이션 */}
        {totalCount > 0 && (
        <PaginationSection
          totalCount={totalCount}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          onArrow={handleArrowClick}
        />
        )}
      </div>
    </div>
  );
}

export default OrderManagement;